import type { FetchLike } from '@/api/client';
import { browserStorage, type StorageLike } from '@/api/tokens';
import { createTvApi, type TvApi } from './api';
import { TvCredentialsStore } from './credentials';
import type { TvHub } from './hub';
import { LazyTvHub } from './lazyHub';

/** Tudo o que a tela da TV (Espectador) usa, montado uma vez com os demais serviços (e substituível nos testes). */
export interface TvServices {
  /** O pareamento guardado neste aparelho. */
  store: TvCredentialsStore;
  api: TvApi;
  /** Tempo real (`/hubs/tv`): só recebe a visão pública. */
  live: TvHub;
}

export interface TvServicesOptions {
  baseUrl: string;
  /** `null` = só na memória. Omitido = `localStorage` do navegador. */
  storage?: StorageLike | null;
  fetch?: FetchLike;
  live?: TvHub;
}

export function createTvServices(options: TvServicesOptions): TvServices {
  const store = new TvCredentialsStore(options.storage === undefined ? browserStorage() : options.storage);

  return {
    store,
    api: createTvApi({
      baseUrl: options.baseUrl,
      token: () => store.get()?.accessToken ?? null,
      fetch: options.fetch,
    }),
    live:
      options.live ??
      new LazyTvHub({
        url: `${options.baseUrl}/hubs/tv`,
        accessToken: () => store.get()?.accessToken ?? null,
      }),
  };
}
